export default __webpack_public_path__ + "static/media/usecase_visualization_collection.98ec0810.png";